interface Props {
  style?: any;
}

export const Logo = (props: Props) => {
  return <img src="/logo.png" style={{ ...props.style, width: 300 }} alt="" />;
};
